import { Route, Switch } from "wouter";
import { HelmetProvider } from "react-helmet-async";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { queryClient } from "@/lib/queryClient";
import Analytics from "@/components/Analytics";
import HomePage from "@/pages/home";
import AboutPage from "@/pages/about";
import ServicesPage from "@/pages/services";
import PackagesPage from "@/pages/packages";
import PackageDetailPage from "@/pages/package-detail";
import TeamPage from "@/pages/team";
import ContactPage from "@/pages/contact";
import CareersPage from "@/pages/careers";
import LiveRatesPage from "@/pages/live-rates";
import LoginPage from "@/pages/login";
import Dashboard from "@/pages/Dashboard";
import SimpleDashboard from "@/pages/SimpleDashboard";
import TestDashboard from "@/pages/TestDashboard";
import PrivacyPolicyPage from "@/pages/privacy-policy";
import TermsOfServicePage from "@/pages/terms-of-service";
import NotFoundPage from "@/pages/not-found";
import { useAuth } from "@/hooks/useAuth";

function App() {
  const { isLoading } = useAuth();

  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <Analytics />
        {isLoading ? (
          <div className="min-h-screen bg-gray-50 flex items-center justify-center">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
              <p className="mt-4 text-gray-600">Loading Travel Wings...</p>
            </div>
          </div>
        ) : (
          <Switch>
            <Route path="/" component={HomePage} />
            <Route path="/about" component={AboutPage} />
            <Route path="/services" component={ServicesPage} />
            <Route path="/packages" component={PackagesPage} />
            <Route path="/packages/:id" component={PackageDetailPage} />
            <Route path="/team" component={TeamPage} />
            <Route path="/contact" component={ContactPage} />
            <Route path="/careers" component={CareersPage} />
            <Route path="/live-rates" component={LiveRatesPage} />
            <Route path="/login" component={LoginPage} />
            <Route path="/dashboard" component={Dashboard} />
            <Route path="/dashboard-simple" component={SimpleDashboard} />
            <Route path="/test-dashboard" component={TestDashboard} />
            <Route path="/privacy-policy" component={PrivacyPolicyPage} />
            <Route path="/terms-of-service" component={TermsOfServicePage} />
            <Route component={NotFoundPage} />
          </Switch>
        )}
        <Toaster />
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;